
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/impressions",
      function () {
        return require("private-next-pages/analytics/impressions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/impressions"])
      });
    }
  